import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

const initGalleryGrid = () => {
  const grid = document.querySelector('[data-photo-grid]');

  // Only run Masonry when a grid exists on the page.
  if (!grid) {
    return;
  }

  // Masonry keeps column widths responsive via the grid-sizer element.
  const masonry = new Masonry(grid, {
    itemSelector: '.photo-item',
    columnWidth: '.grid-sizer',
    gutter: 16,
    percentPosition: true,
    horizontalOrder: true
  });

  // Wait for images to load before forcing layout, then reveal.
  imagesLoaded(grid)
    .on('progress', () => masonry.layout())
    .on('always', () => {
      masonry.layout();
      grid.classList.add('is-ready');
    });
};

export default initGalleryGrid;
